import { db, rtdb } from "@/helpers/firebase";
// import "firebase/firestore";
import localforage from "localforage";

const COLLECTION = "EmergingArtwork";
const collectionRef = db.collection(COLLECTION);

class EmergingArtworkDS {
  async read(_id) {
    const snapshot = await collectionRef.doc(_id).get();
    const data = snapshot.data();
    return data;
    // const dataPromise = new Promise((resolve, reject) => {
    //   localforage.getItem(_id).then(async (cachedData) => {
    //     const ts = await localforage.getItem(`${_id}TS`) || 0;
    //     // const age = (Math.floor((Date.now()/1000) - ts))/86400; // age in days
    //     const age = (Math.floor((Date.now()/1000) - ts))/60; // age in minutes
    //     if (cachedData && (age < 720 || navigator.Online)) resolve(cachedData);
    //     else {
    //       try {
    //         const snapshot = await collectionRef.doc(_id).get();
    //         const data = snapshot.data();
    //         localforage.setItem(_id, data);
    //         localforage.setItem(`${_id}TS`, Math.floor(Date.now()/1000));
    //         resolve(data);
    //       } catch {
    //         reject();
    //       }
    //     }
    //   });
    // });
    // return dataPromise;
  }

  async getPublishedArtistWorkFS(artistId){
    const filters = [{ field: "published", operator: "==", condition: true }, { field: "_artistID", operator: "==", condition: artistId }];
    let snapshot = await this.where(filters).get();
    
    let firstRound = [];
    let featured = [];

    snapshot.forEach((doc) => {
      const info = doc.data();

      const data = {
        _id: doc.id,
        title: info.title,
        artist: info.artist,
        circa: info.circa,
        year: info.year,
        currency: info.currency,
        currentValue: info.currentValue,
        new: info.new,
        // src: `${process.env.VUE_APP_IMAGES_URL}artwork/${doc.id}/${doc.id}_1.jpg?1`,
        url: info.images[0].url,
        flex: 3,
        images: info.images,
        long: info.long,
        short: info.short,
        provenance: info.provenance,
        material: info.material,
      };
      if (info.featured) {
        featured.push(data);
      }
      firstRound.push(data);
    });

    return { featured, firstRound };
    
  }


  async getPreprodArtworkRT() {
    let  dbArtwork = await rtdb.ref("emerging/artwork").child("preprod").get();
  
    const artwork = dbArtwork.val();

    let preprod = []

    for (let artworkId in artwork) {
      const info = artwork[artworkId].info;
      const metrics = artwork[artworkId].metrics;
      const data = {
        _id: artworkId,
        title: info.artwork,
        artist: info.artist,
        currency: metrics.currency,
        currentValue: metrics.currentValue,
        originalValue: metrics.originalValue,
        currentFrameValue: metrics.currentFrameValue,
        originalFrameValue: 1000,
        src: `${process.env.VUE_APP_IMAGES_URL}artwork/preprod/${artworkId}/preprod_${artworkId}.jpg?3`,
        flex: 3,
      };
      preprod.push(data);
    }
    return preprod;
  }

  async getPublishedArtworkRT() {
    let dbArtwork;
    let firstRound = [];
    let featured = [];
    let cachedArtworkEmpty = { featured, firstRound };
    if (!navigator.onLine) {
      try {
        let cachedArtwork = await localforage.getItem("artwork");
        // IndexedDB did not find the data, try localStorage
        if (!cachedArtwork) {
          cachedArtwork = localStorage.getItem("artwork");
          if (cachedArtwork === null) return cachedArtworkEmpty;
          else return JSON.parse(cachedArtwork);
        } else {
          return cachedArtwork;
        }
      } catch (e) {
        return cachedArtworkEmpty;
      }
    }
    try {
      dbArtwork = await rtdb.ref("emerging/artwork").child("published").get();
    } catch {
      try {
        let cachedArtwork = await localforage.getItem("artwork");
        // IndexedDB did not find the data, try localStorage
        if (!cachedArtwork) return cachedArtworkEmpty;
        else return cachedArtwork;
      } catch (e) {
        return cachedArtworkEmpty;
      }
    }

    const artwork = dbArtwork.val();
    for (let artworkId in artwork) {
      const info = artwork[artworkId].info;
      const metrics = artwork[artworkId].metrics;
      const data = {
        _id: artworkId,
        title: info.artwork,
        artist: info.artist,
        stock: info.availableFrames,
        year: info.year,
        currency: metrics.currency,
        currentValue: metrics.currentValue,
        originalValue: metrics.originalValue,
        currentFrameValue: metrics.currentFrameValue,
        originalFrameValue: 1000,
        new: info.new,
        src: `${process.env.VUE_APP_IMAGES_URL}artwork/${artworkId}/${artworkId}_1.jpg?1`,
        flex: 3,
      };
      if (info.featured) {
        featured.push(data);
      }
      firstRound.push(data);
    }
    localforage.setItem("artwork", { featured, firstRound }, function (err) {
      // if err is non-null, we got an error
      if (err) console.log("failed to save cache ", err);
    });

    return { featured, firstRound };
  }

  where(filters) {
    let query = collectionRef;
    for (let f in filters) {
      const filter = filters[f];
      query = query.where(filter.field, filter.operator, filter.condition);
    }
    return query;
  }

  async getPublishedArtwork() {
    const filters = [{ field: "published", operator: "==", condition: true }];
    let dbArtwork = await this.where(filters).get();
    let firstRound = [];
    let featured = [];
    dbArtwork.forEach((doc) => {
      const info = doc.data();

      const data = {
        _id: doc.id,
        title: info.title,
        artist: info.artist,
        circa: info.circa,
        year: info.year,
        currency: info.currency,
        currentValue: info.currentValue,
        originalValue: info.originalValue,
        currentFrameValue: info.currentFrameValue,
        originalFrameValue: 1000,
        new: info.new,
        src: `${process.env.VUE_APP_IMAGES_URL}artwork/${doc.id}/${doc.id}_1.jpg?1`,
        flex: 3,
      };
      if (info.featured) {
        featured.push(data);
      }
      firstRound.push(data);
    });

    return { featured, firstRound };
  }

  getArtworkMetrics(id) {
    return rtdb
      .ref("artwork")
      .child("published")
      .child(id)
      .child("metrics")
      .get();
  }
  getArtworkInfo(id) {
    return rtdb.ref("artwork").child("published").child(id).child("info").get();
  }

  getArtworkTotalFrames(workID) {
    return rtdb
      .ref("/artwork/")
      .child("published")
      .child(workID)
      .child("metrics/totalFrames")
      .get();
  }

  refArtworkMetrics(id) {
    return rtdb.ref(`artwork/published/${id}/metrics`);
  }
}

export default new EmergingArtworkDS();
